import React from "react";

const sections = [
  {
    icon: "📸",
    title: "तस्वीर खींचो, जवाब पाओ",
    desc: "किसी भी सवाल की photo डालो — Kunji AI step-by-step solution देता है, हिंदी में।",
  },
  {
    icon: "📚",
    title: "Revise & Practice",
    desc: "हर chapter के लिए quick revision notes और chapter-wise practice questions।",
  },
  {
    icon: "📝",
    title: "Marks 35 + Test Yourself",
    desc: "वो 35 मार्क के सबसे ज़रूरी सवाल जो हर साल आते हैं — और self-assessment tests।",
  },
  {
    icon: "🎯",
    title: "Previous Year Questions",
    desc: "पिछले 10 साल के board papers — chapter और topic के अनुसार sorted।",
  },
];

const KunjiHighlight = () => {
  return (
    <section
      aria-label="Kunji AI features"
      className="py-14 px-4 bg-gradient-to-b from-yellow-50 to-white"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <p className="inline-block bg-yellow-200 text-yellow-900 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full">
            Inside the app · App के अंदर
          </p>
          <h2 className="mt-3 text-2xl sm:text-3xl font-bold text-gray-900">
            कुंजी AI — आपका personal AI tutor
          </h2>
          <p className="mt-2 text-gray-700 max-w-2xl mx-auto">
            Pathyacharya app के अंदर एक AI tutor मिलता है जो आपके doubts solve
            करता है, revision कराता है, और board exam के सबसे important सवाल
            दिखाता है।
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {sections.map((s) => (
            <div
              key={s.title}
              className="flex gap-4 bg-white rounded-2xl p-5 border border-yellow-100 shadow-sm"
            >
              <div className="text-3xl select-none" aria-hidden>
                {s.icon}
              </div>
              <div>
                <h3 className="font-bold text-gray-900">{s.title}</h3>
                <p className="text-sm text-gray-700 mt-1 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-gray-500 mt-6">
          7-day trial में सब Kunji features unlocked हैं। उसके बाद paid plan के
          साथ access continue रहता है।
        </p>
      </div>
    </section>
  );
};

export default KunjiHighlight;
